import * as React from 'react';
import { shiftDate } from '../../../utils/datetime.js';
import { getLastWeekDay } from '../../AvailabilityCalendar/utils.js';

const useNextWeekDate = (weeks, skip = false)=>{
    return React.useMemo(()=>{
        if (skip || !weeks) {
            return;
        }
        const lastWeekDay = getLastWeekDay(weeks);
        return shiftDate(lastWeekDay, 'day', 1);
    }, [
        skip,
        weeks
    ]);
};

export { useNextWeekDate as default, useNextWeekDate };
//# sourceMappingURL=use-next-week-date.js.map
